import React, {useEffect, useRef, useState} from "react";
import Pdf from "./pdf";
// import {Link} from "react-router-dom";
import {jsPDF} from 'jspdf'
import html2canvas from "html2canvas";
import LoaderPDF from "../ui/loaderPDF";
// @ts-ignore
import scss from './loadingPagePdf.module.scss'
import imagePDFReady from './../../svg/pdf/pdf-loading-image.svg'
import LoaderPDFNotify from "../ui/loaderPDFnotify";
import pica from "pica";

const PdfLoadingPage = ({data, hasDownloadRoute, dataClient }) => {
    const [pdf,setPDF] = useState<any>()
    const [totalPages,setTotalPages] = useState<number>(0)
    const [pdfReady, setPdfReady] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [error,setError] = useState(false)
    const componentRef = useRef<HTMLDivElement>(null);
    const [alertView, setAlertView] = useState(true);
    // const [startLoading, setStartLoading] = useState(false);
    // const [animatedProgress, setAnimatedProgress] = useState(0);

    const rawNameAgent = dataClient ?
        [dataClient?.first_name, dataClient?.last_name]
        .filter(Boolean)
        .join(' ') : ''

    const generatePdf = async () => {
        setLoading(true);
        setLoadingProgress(10);

        try {
            if (componentRef.current) {
                const pdf = new jsPDF({
                    unit: "mm",
                    format: [297, 210], // A4 landscape
                    orientation: "landscape"
                });

                const slideNodes = componentRef.current.querySelectorAll('.pdf-slide');
                const totalSlides = slideNodes.length;
                setTotalPages(totalSlides);

                const picaInstance = pica();

                const pdfWidth = pdf.internal.pageSize.getWidth();   // мм
                const pdfHeight = pdf.internal.pageSize.getHeight(); // мм

                // DPI для перевода мм в px
                const dpi = 96;
                const mmToPx = (mm: number) => Math.round(mm * dpi / 25.4);
                const targetWidthPx = mmToPx(pdfWidth);
                const targetHeightPx = mmToPx(pdfHeight);

                for (let i = 0; i < totalSlides; i++) {
                    const slide = slideNodes[i] as HTMLElement;

                    const originalCanvas = await html2canvas(slide, {
                        scale: 3,
                        useCORS: true,
                        backgroundColor: '#FAFAFA',
                    });

                    // Ресайз до размера PDF страницы в пикселях
                    const resizedCanvas = document.createElement('canvas');
                    resizedCanvas.width = targetWidthPx;
                    resizedCanvas.height = targetHeightPx;

                    await picaInstance.resize(originalCanvas, resizedCanvas, {
                        unsharpAmount: 80,
                        unsharpRadius: 0.6,
                        unsharpThreshold: 2
                    });

                    const imgData = resizedCanvas.toDataURL('image/png', 1.0);

                    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

                    if (i < totalSlides - 1) {
                        pdf.addPage();
                    }

                    const percent = ((i + 1) / totalSlides) * 100;
                    setLoadingProgress(prev => Math.max(prev, percent));
                }

                setPDF(pdf);
            }
        } catch (error) {
            console.error('Ошибка при создании PDF:', error);
            setError(true);
        }
    };

    const downloadPdf = async () => {
        await generatePdf();
    };

    useEffect(() => {
        downloadPdf();
    }, [data, componentRef.current]);

    const setPdfReadyHandler = () => {
        setPdfReady(true);
        setTimeout(() => {
            setAlertView(false);
        }, 4000)
    }

    function sanitizeFileName (name: string) {
        const normalizedName = name.trim().replace(/\s+/g, ' ');
        // Удаляем недопустимые символы
        const resName = normalizedName.replace(/[\\/:*?"<>|]/g, '');
        const fileName = rawNameAgent ? `${resName} - Презентация недвижимости.pdf` : 'Презентация недвижимости.pdf';

        pdf.save(fileName);
    }

    useEffect(() => {
        if (pdfReady && !error) {
            sanitizeFileName(rawNameAgent);
        }
    }, [error, pdf, pdfReady]);
    
    return (
        <>
            {
                !pdfReady && loading && !error &&
                <div className={scss.containerLoading}>
                    <LoaderPDF loadingProgress={loadingProgress}
                               totalPages={totalPages}
                               onAnimationEnd={setPdfReadyHandler}
                    />
                    <div className={scss.loaderPDFDesc}>
                        <p className={scss.loaderPDFdesc_title}>Идёт процесс формирования PDF файла</p>
                        <p className={scss.loaderPDFdesc_subTitle}>Скоро начнётся загрузка файла презентации</p>
                    </div>
                </div>
            }
            {
                error &&
                <div className={scss.containerLoading}>
                    <div className={scss.loaderPDFDesc}>
                        <p className={scss.loaderPDFdesc_title}>Произошла ошибка при загрузке документа</p>
                    </div>
                    {/*<Link className={scss.loaderPDFBtn} to={`/${window.location.search}`}>*/}
                    {/*    Вернуться назад*/}
                    {/*</Link>*/}
                </div>
            }
            {
                pdfReady && !error &&
                <div className={scss.containerLoading}>
                    <div style={{
                        backgroundImage: `url(${imagePDFReady})`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center center",
                        width: "284.99px",
                        height: "261.54px",
                        marginBottom: "67px"
                    }}></div>
                    <div className={scss.loaderPDFDesc}>
                        <p className={scss.loaderPDFdesc_title}>Формирование PDF файла завершено!</p>
                        <p className={scss.loaderPDFdesc_subTitle}>Скачать файл презентации можно по кнопке ниже</p>
                    </div>
                    <div className={scss.loaderButtons}>
                        <button className={scss.loaderPDFBtn_load}
                        onClick={() => {
                            sanitizeFileName(rawNameAgent)
                        }}>
                            Скачать файл
                        </button>
                    </div>
                </div>
            }
            {
                !error &&
                <div
                    ref={componentRef}
                    style={{
                        position: 'absolute',
                        top: '-9999px',
                        left: '-9999px',
                        opacity: 1,
                        pointerEvents: 'none',
                        zIndex: -1,
                    }}
                >
                    <Pdf data={data} status="pdf" hasDownloadRoute={hasDownloadRoute}/>
                </div>
            }
            {
                pdfReady && alertView &&
                    <LoaderPDFNotify text={'Готово! Файл презентации загружен'} status={true} />
            }
            {
                error &&
                    <LoaderPDFNotify
                        text={'Что-то пошло не так! Загрузка приостановлена'}
                        status={false}
                    />
            }
        </>
    );
};

export default PdfLoadingPage;